import { deleteCancellationReasonRequest } from "../../data/cancellationReasonApi";

export async function deleteCancellationReasonUseCase(id) {
  if (!Number.isInteger(Number(id)) || Number(id) <= 0) {
    throw new Error("El motivo de cancelacion no es valido.");
  }

  return await deleteCancellationReasonRequest(id);
}
